import { createGlobalStyle } from 'styled-components';


export const GlobalStyles = createGlobalStyle`
  *,
  *::after,
  *::before {
    box-sizing: border-box;
  }

  body {
    align-items: center;
    background: ${({ theme }) => theme.body};
    color: ${({ theme }) => theme.text};
    display: flex;
    flex-direction: column;
    justify-content: center;
    height: 100vh;
    margin: 0;
    padding: 0;
    font-family: -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, Helvetica, Arial, sans-serif, "Apple Color Emoji", "Segoe UI Emoji", "Segoe UI Symbol";
    transition: all 0.25s linear;
  }

  .custom-popup{
    background: ${({ theme }) => theme.secondaryBackgrounColor};
  }
  .sub-header-dropdown {
    background: ${({ theme }) => theme.secondaryBackgrounColor};
    color: ${({ theme }) => theme.text};
  }

  .slider-fundamental-data {
    background: ${({ theme }) => theme.newBackgroundColor};
    color: ${({ theme }) => theme.text};
  }

  #custom-select-search .select-search .select-search__value input{
    background: ${({ theme }) => theme.secondaryBackgrounColor};
    color: ${({ theme }) => theme.text};
  }

  .select-search__select {
    background: ${({ theme }) => theme.secondaryBackgrounColor};
    color: ${({ theme }) => theme.text};
  }

  #custom-select-search .select-search__value::after {
    border-right: 1px solid ${({ theme }) => theme.text};
    border-bottom: 1px solid ${({ theme }) => theme.text};
  }

  .select-search__option{
    background: ${({ theme }) => theme.secondaryBackgrounColor};
    color: ${({ theme }) => theme.text};
  }

  .app-sidebar{
    background: ${({ theme }) => theme.body};
  }

  .btn-expandable-grid.active-custom{
    background-color: ${({ theme }) => theme.body};
  }

  .btn-expandable-grid {
    border-bottom: 2px solid transparent !important;
    background-color: ${({ theme }) => theme.body};
  }
  
  footer {
    position: absolute;
    bottom: 5%;
    left: 50%;
    transform: translateX(-50%);
  }
  .badge-container {
    background-color: ${({ theme }) => theme.body};
  }

  .ticker-container{
    background: ${({ theme }) => theme.secondaryBackgrounColor};
    color: ${({ theme }) => theme.text};
  }

  .react-date-picker--disabled {
    background: ${({ theme }) => theme.secondaryBackgrounColor};
    color: ${({ theme }) => theme.text};
    opacity: 0.7;
  }
  .react-calendar {
    background: ${({ theme }) => theme.secondaryBackgrounColor};
  }
  .react-calendar__tile--now {
    color: ${({ theme }) => theme.body};
    background : #e0542b
  }
  .react-calendar__tile--now:enabled:hover, .react-calendar__title--now:enabled:focus {
    background : #e0542b
  }
 
  small {
    display: block;
  }
  button {
    display: block;
  }
  a {
    color: ${({ theme }) => theme.text};
  }

  .custom-scrollable ::-webkit-scrollbar-track {
    background-color: ${({ theme }) => theme.newBackgroundColor} !important;
  }


  .ag-root ::-webkit-scrollbar-track {
    background-color: ${({ theme }) => theme.newBackgroundColor} !important;
  }

`;